import { render } from "./ratesComponent.vue?vue&type=template&id=3711ebd3&scoped=true"
import script from "./ratesComponent.vue?vue&type=script&lang=js"
export * from "./ratesComponent.vue?vue&type=script&lang=js"

import "./ratesComponent.vue?vue&type=style&index=0&id=3711ebd3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3711ebd3"]])

export default __exports__